/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {VersionInfo} from './versionInfo';
import {ContextTypeRepresentation} from './contextTypeRepresentation';
import {CountryCodeSpecific} from './countryCodeSpecific';
import {GroupTypeRepresentation} from './groupTypeRepresentation';
import {PropertyTypeRepresentation} from './propertyTypeRepresentation';

export interface AztrixMetadataRepresentation {
  versionInfo?: VersionInfo;
  countryCodeSpecifics?: Array<CountryCodeSpecific>;
  propertyTypes?: Array<PropertyTypeRepresentation>;
  propertyContextTypes?: {[key: string]: {[key: string]: Array<ContextTypeRepresentation>}};
  groupTypes?: {[key: string]: Array<GroupTypeRepresentation>};
  searchPropertyTypes?: {[key: string]: Array<string>};
  categories?: Array<string>;
  availableLanguages?: Array<string>;
  registrationRequirements?: object;
  importProviders?: Array<string>;
}
export namespace AztrixMetadataRepresentation {
  export type SearchPropertyTypesEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const SearchPropertyTypesEnum = {
    USERNAME: 'USERNAME' as SearchPropertyTypesEnum,
    FIRST_NAME: 'FIRST_NAME' as SearchPropertyTypesEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as SearchPropertyTypesEnum,
    LAST_NAME: 'LAST_NAME' as SearchPropertyTypesEnum,
    NAME: 'NAME' as SearchPropertyTypesEnum,
    AVATAR: 'AVATAR' as SearchPropertyTypesEnum,
    GENDER: 'GENDER' as SearchPropertyTypesEnum,
    BIRTHDAY: 'BIRTHDAY' as SearchPropertyTypesEnum,
    FOUNDED: 'FOUNDED' as SearchPropertyTypesEnum,
    DISSOLVED: 'DISSOLVED' as SearchPropertyTypesEnum,
    DAY: 'DAY' as SearchPropertyTypesEnum,
    MONTH: 'MONTH' as SearchPropertyTypesEnum,
    YEAR: 'YEAR' as SearchPropertyTypesEnum,
    EMAIL: 'EMAIL' as SearchPropertyTypesEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as SearchPropertyTypesEnum,
    PHONE: 'PHONE' as SearchPropertyTypesEnum,
    FAX: 'FAX' as SearchPropertyTypesEnum,
    WEBSITE: 'WEBSITE' as SearchPropertyTypesEnum,
    BIC: 'BIC' as SearchPropertyTypesEnum,
    JOB_TITLE: 'JOB_TITLE' as SearchPropertyTypesEnum,
    INDUSTRY: 'INDUSTRY' as SearchPropertyTypesEnum,
    GROUP: 'GROUP' as SearchPropertyTypesEnum,
    REGION: 'REGION' as SearchPropertyTypesEnum,
    ADDRESS: 'ADDRESS' as SearchPropertyTypesEnum,
    STREET: 'STREET' as SearchPropertyTypesEnum,
    COUNTRY: 'COUNTRY' as SearchPropertyTypesEnum,
    BUILDING: 'BUILDING' as SearchPropertyTypesEnum,
    BOX: 'BOX' as SearchPropertyTypesEnum,
    LOCALITY: 'LOCALITY' as SearchPropertyTypesEnum,
    NUMBER: 'NUMBER' as SearchPropertyTypesEnum,
    ZIP: 'ZIP' as SearchPropertyTypesEnum,
    DISTRICT: 'DISTRICT' as SearchPropertyTypesEnum,
    PROVINCE: 'PROVINCE' as SearchPropertyTypesEnum,
    SUBURB: 'SUBURB' as SearchPropertyTypesEnum,
    STATE: 'STATE' as SearchPropertyTypesEnum,
    COUNTY: 'COUNTY' as SearchPropertyTypesEnum,
    LAT_LONG: 'LAT_LONG' as SearchPropertyTypesEnum,
    FACEBOOK: 'FACEBOOK' as SearchPropertyTypesEnum,
    YOUTUBE: 'YOUTUBE' as SearchPropertyTypesEnum,
    INSTAGRAM: 'INSTAGRAM' as SearchPropertyTypesEnum,
    WHATSAPP: 'WHATSAPP' as SearchPropertyTypesEnum,
    WECHAT: 'WECHAT' as SearchPropertyTypesEnum,
    TIKTOK: 'TIKTOK' as SearchPropertyTypesEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as SearchPropertyTypesEnum,
    TELEGRAM: 'TELEGRAM' as SearchPropertyTypesEnum,
    SNAPCHAT: 'SNAPCHAT' as SearchPropertyTypesEnum,
    PINTEREST: 'PINTEREST' as SearchPropertyTypesEnum,
    TWITTER: 'TWITTER' as SearchPropertyTypesEnum,
    REDDIT: 'REDDIT' as SearchPropertyTypesEnum,
    LINKEDIN: 'LINKEDIN' as SearchPropertyTypesEnum,
    VIMEO: 'VIMEO' as SearchPropertyTypesEnum,
    DISCORD: 'DISCORD' as SearchPropertyTypesEnum,
    TWITCH: 'TWITCH' as SearchPropertyTypesEnum,
    TUMBLR: 'TUMBLR' as SearchPropertyTypesEnum,
    MASTODON: 'MASTODON' as SearchPropertyTypesEnum,
    PATREON: 'PATREON' as SearchPropertyTypesEnum,
    KICKSTARTER: 'KICKSTARTER' as SearchPropertyTypesEnum,
    INDIEGOGO: 'INDIEGOGO' as SearchPropertyTypesEnum,
    GOFUNDME: 'GOFUNDME' as SearchPropertyTypesEnum,
    TAKEAWAY: 'TAKEAWAY' as SearchPropertyTypesEnum,
    UBEREATS: 'UBEREATS' as SearchPropertyTypesEnum,
    DELIVEROO: 'DELIVEROO' as SearchPropertyTypesEnum,
    SHIPTO: 'SHIPTO' as SearchPropertyTypesEnum,
    WEIBO: 'WEIBO' as SearchPropertyTypesEnum,
    QQ: 'QQ' as SearchPropertyTypesEnum,
    KUAISHOU: 'KUAISHOU' as SearchPropertyTypesEnum,
    QZONE: 'QZONE' as SearchPropertyTypesEnum,
    SKYPE: 'SKYPE' as SearchPropertyTypesEnum,
    NOTE: 'NOTE' as SearchPropertyTypesEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as SearchPropertyTypesEnum,
    LEGAL_NAME: 'LEGAL_NAME' as SearchPropertyTypesEnum,
    LEGAL_FORM: 'LEGAL_FORM' as SearchPropertyTypesEnum,
    LEGAL_ID: 'LEGAL_ID' as SearchPropertyTypesEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as SearchPropertyTypesEnum,
    JURISDICTION: 'JURISDICTION' as SearchPropertyTypesEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as SearchPropertyTypesEnum,
    PROPOSAL: 'PROPOSAL' as SearchPropertyTypesEnum,
    CATEGORY: 'CATEGORY' as SearchPropertyTypesEnum,
    OPENING_HOURS: 'OPENING_HOURS' as SearchPropertyTypesEnum,
    CUSTOM: 'CUSTOM' as SearchPropertyTypesEnum,
    FILE: 'FILE' as SearchPropertyTypesEnum,
    IMAGE: 'IMAGE' as SearchPropertyTypesEnum,
    FILE_KEY: 'FILE_KEY' as SearchPropertyTypesEnum,
    FILE_NAME: 'FILE_NAME' as SearchPropertyTypesEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as SearchPropertyTypesEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as SearchPropertyTypesEnum,
    DOCUMENT: 'DOCUMENT' as SearchPropertyTypesEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as SearchPropertyTypesEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as SearchPropertyTypesEnum,
  };
}
